import { listeningOfferFromListing } from './sweetSkills';
/** Seller-set listening prices (client mirror of server/api-util/talkPrices.js). Whole USD per 15 min. */
export const TALK_PRICE_DEFAULTS = { chat: 10, voice: 20, video: 30 };
export const TALK_PRICE_MIN = { chat: 1, voice: 5, video: 5 };
export const TALK_PRICE_MAX = 50; // per 15 min (Sam, Oct 22 2026)

export const normalizeTalkPrices = raw => {
  const out = { ...TALK_PRICE_DEFAULTS };
  Object.keys(out).forEach(f => {
    const v = raw && raw[f];
    const n = typeof v === 'string' && v.trim() !== '' ? Number(v) : v;
    // Any numeric rate (incl. legacy $0 / old-format values) clamps into $min..$50; non-numbers keep the default.
    if (typeof n === 'number' && Number.isFinite(n)) out[f] = Math.min(TALK_PRICE_MAX, Math.max(TALK_PRICE_MIN[f], Math.round(n)));
  });
  return out;
};

/** 15-minute listening prices from the Listening entry of the offer list (seller-set). */
export const talkPricesFromListing = listing => ({ ...(listeningOfferFromListing(listing).durations['15'] || {}) });

/** Subunits for a listing + format; null when the seller doesn't offer that format. */
export const talkPriceSubunitsFor = (listing, format) => {
  const p = talkPricesFromListing(listing);
  return Object.prototype.hasOwnProperty.call(p, format) ? p[format] * 100 : null;
};

export const talkPriceLabel = usd => (usd === 0 ? 'Free' : `$${usd}`);
